import React from 'react';
import styled from 'styled-components';
import Connected from './Connected';
import { AppStoreButton, DesktopButton, FDroidButton, PlayStoreButton, WebButton } from './DownloadButtons';

const FooterDownloadSection = styled.section.attrs({
    className: 'container pt-5 pb-6 vstack gap-3'
})``;

const Platforms = styled.div.attrs({
    className: 'text-center'
})`
    padding-top: 150px;
    margin: 0;
`;

const SecondaryHeading = styled.h2`
    color: var(--bs-code-color);
    font-style: normal;
    font-weight: 800;
    line-height: 140%; 
    max-width: 750px;
    margin: 0 auto;
    margin-top: 56px;
    
    @media(min-width: 992px) {
        font-size: 56px;
    }
`;

const SecondarySubHeading = styled.div`
    font-size: 18px;
    margin-top: 10px;
    
    @media(min-width: 992px) {
        font-size: 20px;
    }
`;

const AnimatedConnected = styled(Connected)`
    transform-origin: 37px 40px;
    animation: spin 3s linear infinite;
`; 

const FooterDownloads: React.FC = () => {
    return (
        <FooterDownloadSection id="download">
            <Platforms>
                <AnimatedConnected />
                <SecondaryHeading>Divided by platforms, connected by Ente</SecondaryHeading>
                <SecondarySubHeading>We're everywhere!</SecondarySubHeading>
                <div className='d-flex flex-wrap mt-5 justify-content-center'>
                    <PlayStoreButton />
                    <AppStoreButton />
                    <FDroidButton />
                    <WebButton />
                    <DesktopButton />
                </div>
            </Platforms>
        </FooterDownloadSection>
    );
};

export default FooterDownloads;

